import React from 'react';
import T from 'prop-types';
// utils
import classnames from 'classnames/bind';
// styles
import styles from './QuickReplyChip.module.scss';

const cn = classnames.bind(styles);

// Suggestion-style reply chip for the Farmfeed quick reply row: white, outlined, send icon before the text
const QuickReplyChip = ({ children, className, disabled, onClick, title }) => (
  <button
    type="button"
    className={cn('quick-reply-chip', className)}
    onClick={onClick}
    disabled={disabled}
    title={title}
  >
    <svg
      className={cn('send-icon')}
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M22 2 11 13" />
      <path d="M22 2 15 22l-4-9-9-4z" />
    </svg>
    <span>{children}</span>
  </button>
);

QuickReplyChip.propTypes = {
  children: T.node.isRequired,
  className: T.string,
  disabled: T.bool,
  onClick: T.func.isRequired,
  title: T.string,
};

QuickReplyChip.defaultProps = {
  className: '',
  disabled: false,
  title: undefined,
};

export default QuickReplyChip;
